import {useTranslation} from 'react-i18next'
import {Link} from 'react-router-dom'
import {Tag} from '@/components/ui/tag'
import type {SgsstActionStatus} from '@/hooks/sgsst/plan/use-actions'

export const STATUS_TONE: Record<SgsstActionStatus, 'neutral' | 'amber' | 'green'> = {
  pendiente: 'neutral',
  en_curso: 'amber',
  cumplida: 'green',
}

/** El plan busca, muestra y destella la acción de `?accion=` (`useHighlightParam`). */
export function planAccionHref(businessId: string, actionId: string): string {
  return `/businesses/${businessId}/sgsst/plan?accion=${actionId}`
}

/** La acción del plan vista desde su origen (la fila de la matriz, la norma del registro). */
export function AccionLigadaLink({
  businessId,
  accion,
  testId = 'accion-ligada',
}: {
  businessId: string
  accion: {id: string; descripcion: string; estado: SgsstActionStatus}
  testId?: string
}) {
  const {t} = useTranslation()
  return (
    <span className="flex min-w-0 flex-wrap items-center gap-1.5" data-testid={testId}>
      <Link
        to={planAccionHref(businessId, accion.id)}
        data-testid={`${testId}-link`}
        className="min-w-0 truncate text-xs font-medium text-primary hover:underline">
        {accion.descripcion}
      </Link>
      <Tag tone={STATUS_TONE[accion.estado]} data-testid={`${testId}-estado`}>
        {t(`plan.status.${accion.estado}`)}
      </Tag>
    </span>
  )
}
